module.exports = __webpack_public_path__ + "img/3.28f518fc.jpg";